import {
    STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_BEGIN,
  } from '../constants';
  
  export function getReferencePrices(versionId, year) {
    return (dispatch) => {
      dispatch({
        type: STOCK_TAKING_CAR_MANAGEMENT_GET_REFERENCE_PRICES_BEGIN,
        data: {versionId, year}
      })
    }
  }